module.exports = __webpack_public_path__ + "img/icon-ethical.35ce33fe.svg";